var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Import Videos")])]),_c('import-videos-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }